<div class="flex flex-col items-center justify-center h-full gap-10">
  <i class="ri-emotion-sad-line ri-10x"></i>
  <h1 class="text">Wir konnten diese Seite leider nicht finden.</h1>
</div>